module.exports = __webpack_public_path__ + "media/11_12.8e3a364c.wav";